module.exports = __webpack_public_path__ + "static/media/logo_18_holes.76ea8699.png";